import React from 'react';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';

type Props = {
  basePath: string,
  id: string | number
};

const HistoryButton = (props: Props) => (
  <Button color="primary" style={{ overflow: 'inherit' }}><Link to={`${props.basePath}/${props.id}/show`}>History</Link></Button>
);

export default HistoryButton;



// WEBPACK FOOTER //
// ./src/views/Common/Buttons/HistoryButton.tsx